import { render, staticRenderFns } from "./DailyJournal.vue?vue&type=template&id=874b115a&"
import script from "./DailyJournal.vue?vue&type=script&lang=js&"
export * from "./DailyJournal.vue?vue&type=script&lang=js&"
import style0 from "./DailyJournal.vue?vue&type=style&index=0&id=874b115a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports